import React, { ReactNode } from 'react';

interface Props {
    title: ReactNode;
}

export default function Subheader({ title }: Props) {
    return <div className="terms-subheader">{title}</div>;
}
